export default "__VITE_ASSET__08253c51__"